// Thin, fail-safe wrapper around localStorage. All access is local to the
// user's browser — nothing is ever transmitted (consistent with the privacy
// promise: it's the user's own machine remembering their own work).

export function load(key, fallback = null) {
  try {
    const v = localStorage.getItem(key);
    return v == null ? fallback : v;
  } catch {
    return fallback;
  }
}

export function save(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {}
}

export function remove(key) {
  try {
    localStorage.removeItem(key);
  } catch {}
}
